export const MODAL_NAME = 'LoanAddModal'
